import axios from 'axios';
import { postData } from './axiosUtils';

const mobileApplicationThemeService = {
  list: () => {
    return axios.get(`/api/mobileApplicationTheme/list`).then((response) => {
      return response.data;
    });
  },
  get: (id: any) => {
    return axios
      .get(`/api/mobileApplicationTheme/details/${id}`)
      .then((response) => {
        return response.data;
      });
  },
  create: (entity: any) => {
    return postData({
      url: `/api/mobileApplicationTheme/create`,
      data: entity,
    }).then((response) => {
      return response;
    });
  },
  update: (entity: any) => {
    return postData({
      url: `/api/mobileApplicationTheme/update`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  delete: (id: any) => {
    return postData({
      url: `/api/mobileApplicationTheme/delete/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
};

export default mobileApplicationThemeService;
